export * from './deletedocs.component';
